module.exports = __webpack_public_path__ + "static/media/imsg_toolbar.3b1d9961.png";